<script setup lang="ts">
const { isSocialAuthFlow, clearSocialData } = useAuthSocial();

type Props = {
  currentStep: number;
  isLastStep: boolean;
  nextStepDisabled: boolean;
  setPrevStep: () => void;
  setNextStep: () => void;
};

const { currentStep, isLastStep, nextStepDisabled, setPrevStep, setNextStep } =
  defineProps<Props>();

const { isMultiStepPreRegisterChoiceEnable } = useAuth();

function onClickBackButton() {
  setPrevStep();

  if (isSocialAuthFlow.value) {
    clearSocialData();
  }
}
</script>
<template>
  <div :class="$style.registerFooter">
    <button
      v-if="currentStep > 1 || isMultiStepPreRegisterChoiceEnable"
      :class="['btn-primary', $style.prevButton]"
      type="button"
      @click="onClickBackButton"
    >
      <NuxtIcon
        class="inline"
        name="arrows/arrow_left"
      />
      <span>{{ $t('common.back') }}</span>
    </button>
    <div v-else>
      <AuthSocialAuth buttons-only />
    </div>

    <button
      :class="['btn-primary', $style.nextButton]"
      :disabled="nextStepDisabled"
      type="button"
      @click="setNextStep"
    >
      <template v-if="isLastStep">
        <span>{{ $t('auth.register.register') }}</span>
      </template>
      <template v-else>
        <span>{{ $t('common.next') }}</span>
      </template>
      <NuxtIcon
        class="inline"
        name="arrows/arrow_right"
      />
    </button>
  </div>
</template>

<style module lang="scss">
.registerFooter {
  @apply w-full sticky bottom-0 bg-black/20 z-20 flex justify-between p-3 md:p-4;

  .prevButton {
    @apply bg-transparent text-white/40 font-bold gap-1.5 flex items-center;
  }

  .nextButton {
    @apply rounded-md gap-1.5 flex items-center font-bold;
  }
}
</style>
